// CreatorInfo.jsx
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { defaultUserProfile } from "../../../utils/constant";

export default function CreatorInfo({ childPools, bondAmount, walletAddress, poolCount }) {
  useEffect(() => {
    // console.log(childPools, "Child pools");
  }, [childPools]);

  // ✅ Safely format numeric values with commas and up to 4 decimals
  const formatNumber = (value, decimals = 4) => {
    if (value === undefined || value === null || value === "" || isNaN(value)) return "0";
    return Number(value).toLocaleString(undefined, { maximumFractionDigits: decimals });
  };

  return (
    <div className="creator_side">
      <h3>Creator Info</h3>

      <Link to={`/pools?creatorAddress=${walletAddress}`}>
        <div className="alex_div">
          <div className="hub_div">
            <img
              src={childPools?.createdBy?.imageUrl || defaultUserProfile?.imageUrl}
              className="text_img"
              alt="Creator"
            />
            <h4>{childPools?.createdBy?.name || defaultUserProfile?.name}</h4>
          </div>

          <p>{childPools?.createdBy?.description || defaultUserProfile?.description}</p>

          <div className="bond_text">
            <div className="pool">
              <span>Bond Size</span>
              <div className="innner_textimg">
                <h5>{formatNumber(bondAmount)}</h5>
                {/* <img src="\assets\alex.svg" className="small_icon" /> */}
              </div>
            </div>

            <div className="pool">
              <span>Other Pools</span>
              <h5>{`${formatNumber(poolCount, 0)} Active`}</h5>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
